type Listener = (event: CheckoutUiEvent) => void;

export type CheckoutUiEvent =
  | {
      type: "success";
      amount: number;
      orderId?: string;
      orderNumber?: string;
      transactionId?: string;
      landOn: "step1" | "history";
    }
  | { type: "card_pending"; amount: number; transactionId?: string }
  | { type: "zaincash_failed"; amount: number }
  | { type: "zaincash_cancelled" }
  | { type: "keep_review" };

const listeners = new Set<Listener>();

export function onCheckoutUiEvent(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitCheckoutUiEvent(event: CheckoutUiEvent): void {
  listeners.forEach((fn) => fn(event));
  try {
    sessionStorage.setItem("ahcp.checkout.lastUiEvent", JSON.stringify(event));
  } catch {
    /* ignore */
  }
}

export function consumeCheckoutUiEvent(): CheckoutUiEvent | null {
  try {
    const raw = sessionStorage.getItem("ahcp.checkout.lastUiEvent");
    if (!raw) return null;
    sessionStorage.removeItem("ahcp.checkout.lastUiEvent");
    return JSON.parse(raw) as CheckoutUiEvent;
  } catch {
    return null;
  }
}
